export function isMatchesOp(op: string): op is 'matches' {
  return op === 'matches';
}
